import React, { useEffect, useState } from 'react'
import ModalListaSeleccionCentroCostoPI from './ModalListaSeleccionCentroCostoPI'
import ModalInformacionGuardadaCorrectamenteMP from './ModalInformacionGuardadaCorrectamenteMP'
import ModalErrorInformacionIncorrectaMP from './ModalErrorInformacionIncorrectaMP'
import { getObtenerListadosVariosSelectMaestroProcedimiento, postActualizarMaestroProcedimiento, postObtenerCentrosCostoMP, postObtenerTipoRIPSDeTipoGeneral, postObtenerTipsRIPSMaestroProcedimientos } from '../../../services/Contratacion'
import ModalNPCCentros from './ModalNPCCentros'
import ModalProcedimientosNoOperacionalesMP from './ModalProcedimientosNoOperacionalesMP'
import ModalNPCProcedimientos from './ModalNPCProcedimientos'

const ModalModificarMaestroProcedimientos = ({setmodalOnModificarMaestroProcedimientos,dataUnMaestroProcedimiento, setactualizarDataProcedimientos}) => {
    const [conceptosServicio, setconceptosServicio]=useState([])
    const [finalidadesProcedimiento, setfinalidadesProcedimiento]=useState([])
    const [finalidadesServicio, setfinalidadesServicio]=useState([])    
    const [planes, setplanes]=useState([])
    const [nivelesAtencion,setnivelesAtencion]=useState([])
    const [tiposGenerales, settiposGenerales]=useState([])
    const [tipoRIPS, settipoRIPS]=useState('')
    const [errorCodigo, seterrorCodigo]=useState('')
    const [errorTipoGeneral, seterrorTipoGeneral]=useState('')
    const [errorDescripcion, seterrorDescripcion]=useState('')
    const [errorCentroCosto, seterrorCentroCosto]=useState('')
    const [errorModalidadExamen, seterrorModalidadExamen]=useState('')
    const [errorFecha, seterrorFecha]=useState('')
    const [modalOnCentroCosto, setmodalOnCentroCosto]=useState(false)
    const [perfil, setperfil]=useState('')
    const [requiereDiagnosticoResultado, setrequiereDiagnosticoResultado]=useState('')
    const [requiereDistribucionTerceros, setrequiereDistribucionTerceros]=useState('')
    const [consentimientoInformado, setconsentimientoInformado]=useState('')
    const [citaPrimeraVez, setcitaPrimeraVez]=useState('')
    const [manejaInterfazResultados, setmanejaInterfazResultados]=useState('')
    const [incluirAyudasRapidas, setincluirAyudasRapidas]=useState('')
    const [valoracionPreAnestesica, setvaloracionPreAnestesica]=useState('')
    const [reqInterpretacionRslSalidaClinica, setreqInterpretacionRslSalidaClinica]=useState('')
    const [tipoGeneralData, settipoGeneralData]=useState('')
    const [nivelAtencionData, setnivelAtencionData]=useState('')
    const [planData, setplanData]=useState('')
    const [conceptoServicioData, setconceptoServicioData]=useState('')
    const [finalidadServicioData, setfinalidadServicioData]=useState('')
    const [finalidadProcedimientoData, setfinalidadProcedimientoData]=useState('')
    const [modalOnInformacionGuardaCorrectamente, setmodalOnInformacionGuardaCorrectamente]=useState(false)
    const [modalOnErrorInformacionIncorrecta, setmodalOnErrorInformacionIncorrecta]=useState(false)
    const [modalOnNPCCentros, setmodalOnNPCCentros]=useState(false)
    const [modalOnNPCProcedimientos, setmodalOnNPCProcedimientos]=useState(false)
    const [errorCodigoYaExiste, seterrorCodigoYaExiste]=useState('')
    const [loading, setloading]=useState(true)
    const [codigoCentroCosto, setcodigoCentroCosto]=useState({
      "CNCCOD":'',
      "CnCDsc":''
    })

    const handleCancelarClick=()=>{
        setmodalOnModificarMaestroProcedimientos(false)
    }

    useEffect(()=>{ 
      setloading(false)
      getObtenerListadosVariosSelectMaestroProcedimiento().then((res)=>{
        setloading(true)
        setconceptosServicio(res.data.data.conceptosServicio)
        setfinalidadesProcedimiento(res.data.data.finalidadesProcedimiento)
        setfinalidadesServicio(res.data.data.finalidadesServicio)
        setplanes(res.data.data.planes)
        settiposGenerales(res.data.data.tiposGenerales)
        setnivelesAtencion(res.data.data.nivelesAtencion)  
        //
        //setdataTipoGeneral(dataUnMaestroProcedimiento.TpPrCd)      
      })
    },[])
    
    useEffect(()=>{
      //seterrorCodigo('Procedimiento Requiere Código')
      //seterrorDescripcion('Procedimiento Requiere Descripción')
      //seterrorCentroCosto('Seleccionar Centro Costo')
      setperfil(dataUnMaestroProcedimiento.PrIndPer)
      setrequiereDiagnosticoResultado(dataUnMaestroProcedimiento.PrDiagRsl? dataUnMaestroProcedimiento.PrDiagRsl.trim():'N')
      setrequiereDistribucionTerceros(dataUnMaestroProcedimiento.PrDisTer? dataUnMaestroProcedimiento.PrDisTer.trim(): 'N')
      setconsentimientoInformado(dataUnMaestroProcedimiento.PrInCoIn? dataUnMaestroProcedimiento.PrInCoIn.trim():'N')
      setcitaPrimeraVez(dataUnMaestroProcedimiento.PrPriVez? dataUnMaestroProcedimiento.PrPriVez.trim(): 'N')
      setmanejaInterfazResultados(dataUnMaestroProcedimiento.PrIntRes? dataUnMaestroProcedimiento.PrIntRes.trim(): 'N')
      setincluirAyudasRapidas(dataUnMaestroProcedimiento.prtrmodo? dataUnMaestroProcedimiento.prtrmodo.trim():'N')
      setvaloracionPreAnestesica(dataUnMaestroProcedimiento.PrValPrAn? dataUnMaestroProcedimiento.PrValPrAn.trim(): 'N')
      setreqInterpretacionRslSalidaClinica(dataUnMaestroProcedimiento.PrIndInSC? dataUnMaestroProcedimiento.PrIndInSC.trim():'N')
      settipoGeneralData(dataUnMaestroProcedimiento.TpPrCd)
      setnivelAtencionData(dataUnMaestroProcedimiento.NivCod)
      setplanData(dataUnMaestroProcedimiento.PlnCod)
      setconceptoServicioData(dataUnMaestroProcedimiento.prcpto)
      setfinalidadServicioData(dataUnMaestroProcedimiento.prfinal)
      setfinalidadProcedimientoData(dataUnMaestroProcedimiento.FinProCod)
    },[])

    useEffect(()=>{
      const tipo={
        "TiPrCod": dataUnMaestroProcedimiento.TpPrCd 
      }
      postObtenerTipoRIPSDeTipoGeneral(tipo).then((res)=>{  
        //console.log(res.data.detallesGPrRIPS.GPRIPSDs, ' importante')
        if(res.data){
          settipoRIPS(res.data.detallesGPrRIPS.GPRIPSDs)
        }else{
          settipoRIPS('')
        }
      })  
    },[])

    useEffect(()=>{
      const centro={
        "CNCCOD": dataUnMaestroProcedimiento.PrMCCodi        
      }
      postObtenerCentrosCostoMP(centro).then((res)=>{
        if(res.data.data){
          const dataCentros = res.data.data[0]
          setcodigoCentroCosto({
            "CNCCOD":dataCentros.CNCCOD,
            "CnCDsc":dataCentros.CnCDsc
          })
        }
      })
    },[])

    const handleOnchangeTipoGeneral=(e)=>{
      settipoGeneralData(e.target.value)
      if(e.target.value){
        //seterrorTipoGeneral('')
        const { value, selectedIndex } = e.target;
        const dataset = e.target.options[selectedIndex].dataset;
        //console.log(dataset.tipoRips,'tipo general')
        const tipo={
          "GPRIPSCd": dataset.tipoRips
        }
        postObtenerTipsRIPSMaestroProcedimientos(tipo).then((res)=>{
          //settipoRIPS(res.data.data.TpPrDs)
          //console.log(res.data.data)
          settipoRIPS(res.data.data.GPRIPSDs)
        })  
      }else{
        //seterrorTipoGeneral('Seleccionar Tipo General')
        settipoRIPS('')
      }
      
    }

    const handleOnclickCentroCosto=()=>{
      setmodalOnCentroCosto(true)
    }

    const handleOnsubmitDataMaestroProcedimientos=(e)=>{
      e.preventDefault()
      const dataUpdate={
        "PRCODI": e.target.codigo.value,
        "PrNomb": e.target.descripcion.value,
        "TpPrCd": e.target.tipoGeneral.value,
        "PrIndPer": perfil,
        "PrSta": e.target.estado.value,
        "NivCod": e.target.nivelAtencion.value,
        "PlnCod": e.target.plan.value,
        "PrMCCodi": codigoCentroCosto.CNCCOD, 
        "prcpto": e.target.conceptoServicio.value,
        "prfinal": e.target.finalidadServicio.value,
        "PrTpo": e.target.duracionProcedimiento.value,
        "PrTipAtn": e.target.ambito.value,
        "FinProCod": e.target.finalidadProcedimiento.value,
        "PrModExa":  e.target.modalidadExamen.value,
        "PrEdInc": e.target.numeroEdadInicial.value,
        "PRTPOEIN": e.target.textEdadInicial.value,
        "PrEdFnl": e.target.numeroEdadFinal.value,
        "PRTPOEFN": e.target.textEdadFinal.value,
        "PrSexo": e.target.sexo.value,
        "PrDiagRsl":requiereDiagnosticoResultado,
        "PrDisTer":requiereDistribucionTerceros,
        "PrInCoIn":consentimientoInformado,
        "PrPriVez":citaPrimeraVez,
        "PrIntRes":manejaInterfazResultados,
        "prtrmodo":incluirAyudasRapidas,
        "PrValPrAn":valoracionPreAnestesica,
        "PrIndInSC":reqInterpretacionRslSalidaClinica,
        "PrNoOp": '0' //SIEMPRE SE GUARDA CON ESTE VALOR
      }
      console.log(dataUpdate,'data insert')
   
      
        
      const validarLasFechas = validarFechaInicialYFechaFinal(e.target.numeroEdadInicial.value, e.target.textEdadInicial.value, e.target.numeroEdadFinal.value,e.target.textEdadFinal.value)

        if(!errorCodigo && !errorDescripcion && !errorCentroCosto && validarLasFechas){
            //  postInsertMaestroProcedimiento(dataInsert).then((res)=>{
            // //   console.log(res.data)
            //    setmodalOnInformacionGuardaCorrectamente(true)
            //  })
            //console.log('Entro')
            setloading(false)
            postActualizarMaestroProcedimiento(dataUpdate).then((res)=>{
              setloading(true)
              setmodalOnInformacionGuardaCorrectamente(true)
              setactualizarDataProcedimientos(dataUpdate)
              
            })
          }else{
            //console.log('NO Entro')
            
            setmodalOnErrorInformacionIncorrecta(true)
          }
      
      
      
      
    }

    const validarFechaInicialYFechaFinal=(numeroFechaInicial, stringFechaInicial, numeroFechaFinal , stringFechaFinal)=>{
      //console.log(numeroFechaInicial,'12')
      if(numeroFechaInicial && numeroFechaFinal && (stringFechaInicial !== "X") && (stringFechaFinal !== "X")){
        const unidades = { 'D': 1, 'M': 30, 'A': 365 };
        const valorInicial = parseInt(numeroFechaInicial) * unidades[stringFechaInicial];
        const valorFinal = parseInt(numeroFechaFinal) * unidades[stringFechaFinal];
        if(valorFinal >= valorInicial){
          seterrorFecha('')
          return true
        }else{
          seterrorFecha('Corregir fecha inicial y fecha final')
          return false
        }
      }else{     
        seterrorFecha('')   
        return true
      }
    }

   

    const handleOnchangeCodigo=(e)=>{
      if(e.target.value){
        seterrorCodigo('')
      }else{
        seterrorCodigo('Procedimiento Requiere Código')
      }
    }

    const handleOnchangeDescripcion=(e)=>{
      if(e.target.value){
        seterrorDescripcion('')
      }else{
        seterrorDescripcion('Procedimiento Requiere Descripción')
      }
    }

    const passDataCentroCosto=(data)=>{      
      seterrorCentroCosto('')
      setmodalOnCentroCosto(false)
      setcodigoCentroCosto({
        "CNCCOD": data.CNCCOD,
        "CnCDsc": data.CnCDsc
      })
    }

    const handleChangePerfil=()=>{
      const newValue = perfil === "N" ? "S" : "N";
      setperfil(newValue)
    }

    const handleChangeRequiereDiagnosticoResultado=()=>{
      const newValue = requiereDiagnosticoResultado === "N" ? "S" : "N";
      setrequiereDiagnosticoResultado(newValue)
    }

    const handleChangeRequiereDistribucionTerceros=()=>{
      const newValue = requiereDistribucionTerceros === "N" ? "S" : "N";
      setrequiereDistribucionTerceros(newValue)
    }

    const handleChangeConsentimientoInformado=()=>{
      const newValue = consentimientoInformado === "N" ? "S" : "N";
      setconsentimientoInformado(newValue)
    }

    const handleChangeCitaPrimeraVez=()=>{
      const newValue = citaPrimeraVez === "N" ? "S" : "N";
      setcitaPrimeraVez(newValue)
    }

    const handleChangeManejaInterfazResultados=()=>{
      const newValue = manejaInterfazResultados === "N" ? "S" : "N";
      setmanejaInterfazResultados(newValue)
    }

    const handleChangeIncluirAyudasRapidas=()=>{
      const newValue = incluirAyudasRapidas === "N" ? "S" : "N";
      setincluirAyudasRapidas(newValue)
    }

    const handleChangeValoracionPreAnestesica=()=>{
      const newValue = valoracionPreAnestesica === "N" ? "S" : "N";
      setvaloracionPreAnestesica(newValue)
    }

    const handleChangeReqInterpretacionRslSalidaClinica=()=>{
      const newValue = reqInterpretacionRslSalidaClinica === "N" ? "S" : "N";
      setreqInterpretacionRslSalidaClinica(newValue)
    }

    const handleOnClickNPCCentros=()=>{
      setmodalOnNPCCentros(true)
    }

    const handleOnClickNPCProcedimientos=()=>{
      setmodalOnNPCProcedimientos(true)
    }

    const handleChangeNivelAtencion=(e)=>{
      setnivelAtencionData(e.target.value)
    }

    const handleChangePlan=(e)=>{
      setplanData(e.target.value)
    }

    const handleChangeConceptoServicio=(e)=>{
      setconceptoServicioData(e.target.value)
    }

    const handleChangeFinalidadServicio=(e)=>{
      setfinalidadServicioData(e.target.value)
    }

    const handleChangeFinalidadProcedimiento=(e)=>{
      setfinalidadProcedimientoData(e.target.value)
    }

    const handleChangeModalidadExamen=(e)=>{
      const newValue = e.target.value
      if(newValue.length > 2){
        seterrorModalidadExamen('Corregir solo se pueden ingresar 2 letras en Modalidad Examen')
      }else{
        seterrorModalidadExamen('')
      }
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
       <div className="sm:h-[calc(100%)] max-w-7xl   mx-auto relative w-auto pointer-events-none ">
        <div className=" max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Modificar Maestros Procedimientos
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative px-2">
            <form onSubmit={handleOnsubmitDataMaestroProcedimientos}>
              <div className="flex py-2 text-left">
                <div className="w-1/3">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código
                  </label>
                  <input
                    //onChange={handleOnchangeCodigo}
                    disabled={true}
                    defaultValue={dataUnMaestroProcedimiento.PRCODI}           
                    type="text"
                    name="codigo"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                      {errorCodigo}
                    </label>
                  </div>
                  <div className="w-2/3 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  <textarea
                    onChange={handleOnchangeDescripcion} 
                    defaultValue={dataUnMaestroProcedimiento.PrNomb}               
                    type="text"
                    name="descripcion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorDescripcion}
                  </label>
                  </div>
                  
              </div>
              <div className="flex py-2 text-left">
                <div className="w-2/3">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Tipo general
                  </label>
                  <select       
                    onChange={handleOnchangeTipoGeneral}  
                    value={tipoGeneralData}           
                    //type="text"
                    name="tipoGeneral"                    
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"                    
                  >
                    {
                      tiposGenerales.map((item)=>(
                        <option value={item.TiPrCod} key={item.TiPrCod} data-tipo-rips={item.GPRIPSCd}>{item.TiPrDes}</option>
                      ))
                    }
                  </select>
                  </div>
                  <div className="w-1/3 ml-2 text-center ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Perfil?
                  </label>
                    <div className="topping ml-2">
                      <input
                        type="checkbox"
                        checked={perfil === "S"}
                        onChange={handleChangePerfil}
                      />                          
                    </div>
                  </div>
              </div>
              <div className="flex py-2 text-left">
                <div className="w-1/2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Tipo RIPS
                  </label>
                  <input       
                    value={tipoRIPS}             
                    type="text"
                    disabled={true}
                    name="cedula"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  </div>
                  <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Estado
                  </label>
                  <select                    
                    type="text"
                    name="estado"
                    defaultValue={dataUnMaestroProcedimiento.PrSta}
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="S">Activo</option>
                        <option value="N">Inactivo</option>
                  </select>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nivel Atención
                    </label>
                    <select
                    value={nivelAtencionData}  
                    onChange={handleChangeNivelAtencion}                
                    //type="text"
                    name="nivelAtencion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    {
                      nivelesAtencion.map((item)=>(
                        <option value={item.NivCod} key={item.NivCod}>{item.NivDsc}</option>
                      ))
                    }
                  </select>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Plan
                    </label>
                    <select
                    value={planData}  
                    onChange={handleChangePlan}               
                    type="text"
                    name="plan"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    {
                      planes.map((item)=>(
                        <option value={item.PlnCod} key={item.PlnCod}>{item.PlnDsc}</option>
                      ))
                    }
                  </select>
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Centro costo codigo
                    </label>
                    <input       
                      onFocus={handleOnclickCentroCosto}
                      value={codigoCentroCosto.CNCCOD}          
                      type="text"
                      name="centroCosto"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCentroCosto}
                  </label>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Centro costo
                    </label>
                    <input       
                      disabled={true}
                      value={codigoCentroCosto.CnCDsc}          
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Concepto servicio
                    </label>
                    <select
                    value={conceptoServicioData}       
                    onChange={handleChangeConceptoServicio}    
                    type="text"
                    name="conceptoServicio"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    {
                      conceptosServicio.map((item)=>(
                        <option value={item.cptcod} key={item.cptcod}>{item.cptdesc}</option>
                      ))
                    }
                  </select>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Finalidad servicio
                    </label>
                    <select
                    value={finalidadServicioData}  
                    onChange={handleChangeFinalidadServicio}     
                    type="text"
                    name="finalidadServicio"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    {
                      finalidadesServicio.map((item)=>(
                        <option value={item.FinCod} key={item.FinCod}>{item.FinDesc}</option>
                      ))
                    }
                  </select>
                    </div>
                    
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Duración procedimiento
                    </label>
                    <input
                      defaultValue={dataUnMaestroProcedimiento.PrTpo}   
                      type="text"
                      name="duracionProcedimiento"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Se puede ordenar para el Ambito
                    </label>
                    <select
                    defaultValue={dataUnMaestroProcedimiento.PrTipAtn}            
                    type="text"
                    name="ambito"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="I">Intrahospitalario - Cirugía Ambulatoria</option>
                        <option value="E">Consulta Externa</option>
                        <option value="T">Todos los tipos de atención</option>
                  </select>
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Finalidad procedimiento
                    </label>
                    <select
                    value={finalidadProcedimientoData} 
                    onChange={handleChangeFinalidadProcedimiento}     
                    type="text"
                    name="finalidadProcedimiento"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >
                    {
                      finalidadesProcedimiento.map((item)=>(
                        <option value={item.FinProCod} key={item.FinProCod}>{item.FinProDesc}</option>
                      ))
                    }
                  </select>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Modalidad Examen
                    </label>
                    <input
                      defaultValue={dataUnMaestroProcedimiento.PrModExa}       
                      onChange={handleChangeModalidadExamen}    
                      type="text"
                      name="modalidadExamen"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder="Solo dos Caracteres"
                    />
                    
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/5">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Edad Inicial
                    </label>
                    <input
                      defaultValue={dataUnMaestroProcedimiento.PrEdInc}        
                      type="number"
                      name="numeroEdadInicial"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                    <div className="w-1/5 ml-2">
                    <label className="form-label inline-block mb-6 text-gray-900 font-medium ">
                      
                    </label>
                    <select
                    defaultValue={dataUnMaestroProcedimiento.PRTPOEIN}    
                    type="text"
                    name="textEdadInicial"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                
                        <option value="X">---</option>    
                        <option value="A">Año</option>
                        <option value="M">Mes</option>
                        <option value="D">Día</option>
                  </select>
                    </div>
                    <div className="w-1/5 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Edad Final
                    </label>
                    <input
                      defaultValue={dataUnMaestroProcedimiento.PrEdFnl}          
                      type="number"
                      name="numeroEdadFinal"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                    <div className="w-1/5 ml-2">
                    <label className="form-label inline-block mb-6 text-gray-900 font-medium ">
                      
                    </label>
                    <select
                    defaultValue={dataUnMaestroProcedimiento.PRTPOEFN}             
                    type="text"
                    name="textEdadFinal"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="X">---</option>
                        <option value="A">Año</option>
                        <option value="M">Mes</option>
                        <option value="D">Día</option>
                  </select>
                    </div>
                    <div className="w-1/5 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Sexo
                    </label>
                    <select
                    defaultValue={dataUnMaestroProcedimiento.PrSexo}            
                    type="text"
                    name="sexo"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="A">Ambos Sexos</option>
                        <option value="F">Femenino</option>
                        <option value="M">Masculino</option>
                  </select>
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={requiereDiagnosticoResultado === "S"}
                        onChange={handleChangeRequiereDiagnosticoResultado}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Requiere Diagnóstico en Resultado?
                      </label>
                    </div>
                  </div>
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={requiereDistribucionTerceros === "S"}
                        onChange={handleChangeRequiereDistribucionTerceros}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Requiere Distribución de Terceros?
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={consentimientoInformado === "S"}
                        onChange={handleChangeConsentimientoInformado}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Consentimiento Informado?
                      </label>
                    </div>
                  </div>
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={citaPrimeraVez === "S"}
                        onChange={handleChangeCitaPrimeraVez}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                       Cita Primera Vez?
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={manejaInterfazResultados === "S"}
                        onChange={handleChangeManejaInterfazResultados}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Maneja Interfaz de Resultados?
                      </label>
                    </div>
                  </div>
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={incluirAyudasRapidas === "S"}
                        onChange={handleChangeIncluirAyudasRapidas}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                       Incluir en Ayudas Rápidas
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={valoracionPreAnestesica === "S"}
                        onChange={handleChangeValoracionPreAnestesica}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Valoración Pre-Anestésica
                      </label>
                    </div>
                  </div>
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={reqInterpretacionRslSalidaClinica === "S"}
                        onChange={handleChangeReqInterpretacionRslSalidaClinica}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                       Req Interpretación Rsl. Salida Clínica
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center p-2 border-t border-gray-200 rounded-b-md">
  {/* <!-- Div para el botón 'lista' alineado a la izquierda --> */}
  <div>
    <button
      type="button"
      onClick={handleOnClickNPCCentros}
      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
    >
      NPC Centros
    </button>
    <button
      onClick={handleOnClickNPCProcedimientos}
      type="button"
      className="inline-block px-4 ml-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
    >
      NPC Procedimientos
    </button>
  </div>

  {/* <!-- Div para los botones 'Cerrar' y 'Guardar' alineados a la derecha --> */}
  <div className='text-right'>
    <button
      type="button"
      onClick={handleCancelarClick}
      className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
      data-bs-dismiss="modal"
    >
      Cerrar
    </button>
    <button
      type="submit"
      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
    >
      Guardar
    </button>
  </div>
</div>
                
            </form>
            
          </div>
          
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }     
      {modalOnCentroCosto? <ModalListaSeleccionCentroCostoPI setmodalOnCentroCosto={setmodalOnCentroCosto} passDataCentroCosto={passDataCentroCosto}/>:null}
      {modalOnInformacionGuardaCorrectamente? <ModalInformacionGuardadaCorrectamenteMP setmodalOnInformacionGuardaCorrectamente={setmodalOnInformacionGuardaCorrectamente} setmodalOnMaestroProcedimientos={setmodalOnModificarMaestroProcedimientos}/>:null}
      {modalOnErrorInformacionIncorrecta? <ModalErrorInformacionIncorrectaMP setmodalOnErrorInformacionIncorrecta={setmodalOnErrorInformacionIncorrecta} errorCodigo={errorCodigo} errorDescripcion={errorDescripcion} errorCentroCosto={errorCentroCosto} errorCodigoYaExiste={errorCodigoYaExiste} errorTipoGeneral={errorTipoGeneral} errorFecha={errorFecha} errorModalidadExamen={errorModalidadExamen}/>:null}
      {modalOnNPCCentros? <ModalNPCCentros setmodalOnNPCCentros={setmodalOnNPCCentros} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento}/>:null}
      {/* {modalOnNPCProcedimientos? <ModalProcedimientosNoOperacionalesMP setmodalOnNPCProcedimientos={setmodalOnNPCProcedimientos} />:null} */}
      {modalOnNPCProcedimientos? <ModalNPCProcedimientos setmodalOnNPCProcedimientos={setmodalOnNPCProcedimientos} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento}/>:null}
    </div>
  )
}

export default ModalModificarMaestroProcedimientos